import { useQuery } from "react-query";
import axios from "axios";
import { setHeaders } from "../../../actions/User";
import * as config from "../../../app.config";


const getAutoDGReportData = async (plate_uuid) => {

    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/adg/get_dg_report/${plate_uuid}`, {

        headers: headerConfig
    });
    return data;
}


export default function useFetchAutoDGReportData(plate_uuid, options = {}) {
    return useQuery(["autodgreportdata", plate_uuid], () => getAutoDGReportData(plate_uuid), options);
};